import type { Duration } from '@here/api'
import type { Component, JSX } from 'solid-js'
import { Badge } from '../ui/badge'
import { Text } from '../ui/text'

interface DurationDisplayProps {
	duration: Duration
}

/**
 * Simple Solid component that shows a label and a badge depending on duration.
 * Uses inline styles for a minimal, framework-agnostic badge layout.
 */
export const DurationDisplay: Component<DurationDisplayProps> = (props) => {
	const durationMap: Record<Duration, JSX.Element> = {
		intraday: (
			<>
				<Text>&lt; Daily</Text>
				<Badge
					ml="auto"
					children="Linear"
				/>
			</>
		),
		multiday: (
			<>
				<Text> &gt; Daily</Text>
				<Badge
					ml="auto"
					children="Log"
				/>
			</>
		),
	}

	return durationMap[props.duration]
}
